import React, { useMemo } from 'react';
import { flowRight, isEmpty, sortBy } from 'lodash-es';

const EDMUNDS = 'Edmunds';
const NEGATIVE = 'negative';

const getOpinionLabels = ({ componentParams, trimSummary, editorialTrims }) => {
  if (isEmpty(trimSummary) || isEmpty(editorialTrims)) return [];
  const llmLabels = componentParams.labels;
  const getLabelsByTrim = trims => trims.find(({ trim }) => trim === trimSummary.trim)?.labels || [];
  const filterOutRedundantLabels = labelsConfig => labelsConfig.filter(({ label }) => llmLabels.includes(label));
  const transformLabelsAuthors = labelsConfig =>
    labelsConfig.map(label => ({
      ...label,
      authors: label.authors?.slice(0, 2).filter(author => author.name !== EDMUNDS) || [],
    }));
  const sortByLlmLabels = labelsConfig =>
    llmLabels.reduce((result, label) => {
      const labelConfig = labelsConfig.find(labelItem => labelItem.label === label);
      return labelConfig ? [...result, labelConfig] : result;
    }, []);
  const sortByType = labels => sortBy(labels, label => label.type === NEGATIVE);

  return flowRight([sortByType, sortByLlmLabels, transformLabelsAuthors, filterOutRedundantLabels, getLabelsByTrim])(
    editorialTrims
  );
};

export function withOpinionDataAdapter(WrappedComponent) {
  function OpinionDataAdapter(props) {
    const { editorialTrims, trimSummary, componentParams, ...rest } = props;

    const opinionLabels = useMemo(() => {
      if (!editorialTrims) {
        return editorialTrims;
      }

      return getOpinionLabels({ componentParams, trimSummary, editorialTrims });
    }, [componentParams, editorialTrims, trimSummary]);

    return <WrappedComponent opinionLabels={opinionLabels} {...rest} />;
  }

  OpinionDataAdapter.displayName = `withOpinionDataAdapter(${WrappedComponent.displayName || WrappedComponent.name})`;

  return OpinionDataAdapter;
}
